// extracted by mini-css-extract-plugin
module.exports = {"root":"FeaturesGrid_root__rsFai","featuresGrid":"FeaturesGrid_featuresGrid__VeDLD"};